import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import NavBar from 'components/toyotaPremium/NavBar';

const PAGE_HANDLES = {
  'sales-rep-chatroom': {
    title: '專屬諮詢',
    navLeft: 'goBack',
    navRight: 'closePage',
  },
  'user-chatroom': {
    title: '專屬諮詢',
    navLeft: 'goBack',
    navRight: 'closePage',
  },
  consultation: {
    title: '專屬諮詢',
    navLeft: 'returnToLine',
    navRight: 'closePage',
  },
  'branch-list': {
    title: '專屬諮詢',
    navLeft: 'returnToLine',
    navRight: 'closePage',
  },
  'conversation-list': {
    title: '專屬諮詢',
    navLeft: 'returnToLine',
    navRight: 'closePage',
  },
  'member-services': {
    title: '車主服務',
    navLeft: 'returnToLine',
    navRight: 'closePage',
  },
  'custom-wallpaper': {
    title: '客製桌布',
    navLeft: 'returnToLine',
    navRight: 'closePage',
  },
};

const getPageHandle = (pathname) => {
  const segments = pathname.replace(/\/+$/, '').split('/').filter(Boolean);
  const slug = [...segments]
    .reverse()
    .find((segment) => PAGE_HANDLES[segment]);
  return (
    PAGE_HANDLES[slug] || {
      title: '',
      navLeft: 'goBack',
      navRight: 'closePage',
    }
  );
};

const Layout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title, navLeft, navRight } = getPageHandle(pathname);

  // navbar 左右 icon 按鈕
  // todo1: 左邊返回上一頁；沒有上一頁時返回 LINE
  //   (ex. UserChatRoom -> BranchList, SalesChatRoom -> ConversationList)
  //   (其他頁面沒有上一頁，都是直接返回 LINE)
  // todo2: 右邊關閉按鈕關閉 webview
  const handleNavLeft = () => {
    if (navLeft === 'goBack') {
      navigate(-1);
      return;
    }
    if (navLeft === 'returnToLine') {
      console.log('return to line app');
      return;
    }
  };

  const handleNavRight = () => {
    if (navRight === 'closePage') {
      console.log('close window');
      return;
    }
  };

  return (
    <div className="app-layout">
      <NavBar
        title={title}
        onLeftButtonClick={handleNavLeft}
        onRightButtonClick={handleNavRight}
      />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
